import { PDFCustomDataKey } from '@aline/common';
import type { Core } from '@pdftron/webviewer';
import { pdfTronCore } from 'src/components/viewer/viewer-context';

export function getIsSignatureStampAnnotation(
  annotation: Core.Annotations.Annotation
): annotation is Core.Annotations.StampAnnotation {
  return (
    annotation instanceof pdfTronCore.Annotations.StampAnnotation &&
    Boolean(annotation.getCustomData(PDFCustomDataKey.signatureImgId))
  );
}

export async function setSignatureStampImageData(
  annotation: Core.Annotations.StampAnnotation,
  imageData: string
) {
  await annotation.setImageData(imageData);
  annotation.ImageData = imageData;
}
